import { type Form, type FormField } from '@wix/ambassador-forms-v4-form/types';

import { FIELD_TYPES } from '../constants';

export const hasMultilineAddress = (form?: Form) => {
  return Boolean(
    [...(form?.fields || []), ...(form?.deletedFields || [])].some(
      (field) =>
        field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS ||
        field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS,
    ),
  );
};

export const isMultilineAddressField = (field: FormField) =>
  field.view?.fieldType === FIELD_TYPES.MULTILINE_ADDRESS ||
  field.view?.fieldType === FIELD_TYPES.BOOKINGS_ADDRESS;
